import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { HttpParams } from "@angular/common/http";
import {
  AfterViewInit,
  Component,
  DoCheck,
  ElementRef,
  HostListener,
  NgZone,
  OnInit,
  ViewChild,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Meta, Title } from "@angular/platform-browser";
import { ActivatedRoute, Router } from "@angular/router";
import * as moment from "moment";
import { Moment } from "moment";
import {
  debounceTime,
  distinctUntilChanged,
  pairwise,
  startWith,
} from "rxjs/operators";
import { BackwardService } from "src/app/services/backward.service";
import { CONFIG } from "../../core/config/config";
import { DoctorSearchResultModel } from "../../models/doctor-search-result.model";
import { ApiService, LanguageService, UserService } from "../../services";
import { ProductService } from "../../services/product.service";
import { RegionService } from "../../services/region.service";
import { SearchService } from "../../services/search.service";
import { SpecialtyService } from "../../services/specialty.service";
import { CovidWarningComponent } from "../../shared/dialogs/covid-warning/covid-warning.component";
import {
  getZoneDiffTime,
  momentGeoTimeParser,
} from "../../shared/helpers/moment-geo-time";
import { ClinicService } from "../../shared/services/clinic.service";
import { InsuranceService } from "../../shared/services/insurance.service";
import { LoadingService } from "../../shared/services/loading.service";
import { SeoOptimizationService } from "../../shared/services/seo-optimization.service";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-search-page",
  templateUrl: "./search-page.component.html",
  styleUrls: ["./search-page.component.scss"],
  animations: [
    trigger("slideDown", [
      state(
        "true",
        style([
          // {transform: 'translateY(300px)'},
          { position: "fixed" },
          { zIndex: 10 },
          { paddingLeft: "45px" },
          { top: "90px" },
        ])
      ),
      state("false", style({ transform: "translateY(0)" })),
      transition("false <=> true", animate(500)),
    ]),
  ],
})
export class SearchPageComponent implements OnInit, AfterViewInit, DoCheck {
  public cLang = CONFIG.LANGS.LANG_DATA.DEFAULT_LANG;
  public searchServiceType: number = null;
  public Specialties: any = [];
  public cities: any = [];
  public isIos: boolean = false;
  public gender: any = [];
  public genderId: number;
  public serviceTypes: any = [];
  public languages: any = [];
  public active: any = [];
  public toggleDetail: boolean = false;
  public keyword: string;
  public cityId: number = null;
  public date: Moment;
  specialtyId: number;
  searchFormGroup: UntypedFormGroup;
  searchResult: DoctorSearchResultModel[] = [];
  maxDate: Moment;
  currentPage = 0;
  totalPageCount: 0;
  totalResultCount: number;
  isInsuranceBubble = false;

  nothingFound = false;
  searchableDates = [];
  minDate: any;
  windowScrolled = window ? window.pageYOffset > 250 : false;
  clinics = [];
  activeSpecialtyName: string = "";
  isSpecialtyPage = false;
  @ViewChild("specialtyInfo") specialtyInfo: ElementRef<HTMLDivElement>;
  @ViewChild('scrollTarget') scrollTarget: ElementRef;
  private hasScrolled = false;

  showFullSpecialtyInfo: boolean = false;
  insuranceProvider = [];
  private allSpecialties = [];
  private clearDoctorId = true;
  private isBubble: boolean;
  public selectedLanguage = localStorage.getItem("CurLang") || "ka";
  specialtyName = "";

  constructor(
    private translate: TranslateService,
    public LS: LanguageService,
    public API: ApiService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private loadingService: LoadingService,
    private backward: BackwardService,
    private specialtyService: SpecialtyService,
    private clinicService: ClinicService,
    private dialog: MatDialog,
    private productService: ProductService,
    private userService: UserService,
    private regionService: RegionService,
    private searchService: SearchService,
    private title: Title,
    private meta: Meta,
    private insuranceService: InsuranceService,
    private seoOptimizationService: SeoOptimizationService,
    private zone: NgZone
  ) {
    this.cLang = this.LS.getLang();
    this.initSpecialties();
    this.initServiceTypes();
    this.initGender();
    this.initLanguages();
    this.initCities();
    this.getClinics();
    this.userService.getUser.subscribe((user: any) => {
      console.log('user', this.activeRoute.snapshot.queryParamMap.has('doctor'));
      if (user && user.isDoctor && !this.activeRoute.snapshot.queryParamMap.has('doctor')) {
        this.router.navigate([""]).then(() => {
          return;
        });
      }
      if (this.activeRoute.snapshot.queryParamMap.has('doctor')) {
        localStorage.setItem('bookingFromDoctor', 'true');
      }
    });
  }

  foundItem = [];

  get serviceTypeId() {
    return this.searchFormGroup.get("ServiceTypeId");
  }

  @HostListener("window:scroll", ["$event"])
  onWindowScroll(e: any) {
    this.windowScrolled = window.pageYOffset > 250;
  }

  ngAfterViewInit() {
    this.translate.get("i-use-redmed").subscribe((event) => {
      this.title.setTitle(this.translate.instant("search") + " - Redmed");
    });
    this.scrollToElementIfNeeded();
  }

  ngDoCheck(): void {
    // Additional checks for when your data changes
    this.scrollToElementIfNeeded();
  }

  private scrollToElementIfNeeded(): void {
    // Check if the condition is met and we haven't scrolled yet
    if (this.searchResult.length > 0 && !this.hasScrolled) {
      // Ensuring scrolling happens outside of Angular to avoid performance issues
      this.zone.runOutsideAngular(() => {
        setTimeout(() => {
          if (this.scrollTarget && window.innerWidth <= 768) {
            this.scrollTarget.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            this.hasScrolled = true; // Prevents multiple scrolls
          }
        }, 0);
      });
    }
  }

  ngOnInit() {
    this.maxDate = moment();
    this.minDate = moment();
    this.maxDate.date(this.maxDate.date() + 31);
    this.loadingService.setApplicationLoading(true);
    this.buildSearchFormGroup();
    if (this.activeRoute.snapshot.queryParamMap.has("insurance")) {
      this.isInsuranceBubble = true;
    }
    if (this.activeRoute.snapshot.queryParamMap.has("specId")) {
      const id = Number.parseInt(
        this.activeRoute.snapshot.queryParamMap.get("specId")
      );
      this.specialtyId = id ? id : null;
      this.searchFormGroup.get("SpecialityId").setValue(this.specialtyId);
    }
    if (this.activeRoute.snapshot.queryParamMap.has("clinic")) {
      this.searchFormGroup
        .get("clinic")
        .setValue(
          Number.parseInt(this.activeRoute.snapshot.queryParamMap.get("clinic"))
        );
    }
    if (this.activeRoute.snapshot.queryParamMap.has("providerId")) {
      this.searchFormGroup
        .get("providerId")
        .setValue(
          Number.parseInt(
            this.activeRoute.snapshot.queryParamMap.get("providerId")
          )
        );
    }
    if (this.activeRoute.snapshot.queryParamMap.has("foreign")) {
      this.searchFormGroup.get("onlyForeignDoctors").setValue(true);
    }
    if (this.activeRoute.snapshot.queryParamMap.has("serviceType")) {
      this.searchServiceType = parseInt(
        this.activeRoute.snapshot.queryParamMap.get("serviceType")
      );
      this.searchFormGroup
        .get("ServiceTypeId")
        .setValue(this.searchServiceType);
      if (!this.searchServiceType) {
        this.searchFormGroup.get("ServiceTypeId").setValue(1);
      }
    } else {
      this.searchFormGroup.get("ServiceTypeId").setValue(1);
    }
    if (this.activeRoute.snapshot.queryParamMap.has("keyword")) {
      this.keyword = this.activeRoute.snapshot.queryParamMap.get("keyword");
      this.searchFormGroup.get("FullName").setValue(this.keyword);
    }
    if (this.activeRoute.snapshot.queryParamMap.has("cityId")) {
      this.cityId = parseInt(
        this.activeRoute.snapshot.queryParamMap.get("cityId")
      );
    }
    if (this.activeRoute.snapshot.queryParamMap.has("date")) {
      this.date = moment(
        this.activeRoute.snapshot.queryParamMap.get("date").replace(/-/g, "/"),
        "DD-MM-YYYY"
      );
      if (this.date.isSameOrAfter(this.maxDate, "day")) {
        this.date = this.maxDate.clone().subtract(3, "day");
      }
      this.searchFormGroup.get("SlotDateFrom").setValue(this.date);
      if (moment(this.date).isSameOrBefore(moment(), "day")) {
        this.date = moment();
      }
      this.searchFormGroup.get("SlotDateFrom").setValue(moment(this.date));
      this.replaceDate().then(() => {});
    }
    if (this.activeRoute.snapshot.queryParamMap.has("is-bubble")) {
      this.isBubble = true;
      this.Specialties.push({
        id: 0,
        instantCallEnabled: null,
        specialityName: "COVID 19 ოჯახის ექიმი/პედიატრი",
        specialityNameEng: "",
        specialityNameLat: "COVID-19-ojaxis-ekimi/pediatri",
      });
      this.searchFormGroup.get("SpecialityId").setValue(0);
    }
    if (this.date) {
      this.generateSearchableDates(this.date);
    } else {
      this.date = moment();
      this.searchFormGroup.get("SlotDateFrom").setValue(moment(this.date));
      this.generateSearchableDates(moment());
    }

    // if (this.selectedLanguage == "en") {
    //   const specialtyCase = this.activeRoute.snapshot.paramMap
    //     .get("specialtyName")
    //     .split("");
    //   this.specialtyName =
    //     specialtyCase[0].toUpperCase() +
    //     specialtyCase.splice(1, specialtyCase.length - 1).join("");
    // } else {
    this.specialtyName =
      this.activeRoute.snapshot.paramMap.get("specialtyName");

    if (this.specialtyName) {
      this.checkForSearchGroupChanges();
      this.specialtyService
        .getAllSpecialties()
        .subscribe((specialties: any[]) => {
          this.isSpecialtyPage = true;
          const specialty = specialties.find(
            (specialty) => specialty.specialityNameLat === this.specialtyName
          );
          this.searchFormGroup.get("SpecialityId").setValue(specialty.id);
          this.title.setTitle(
            `${specialty.specialityName} -  ${this.translate.instant(
              "doctor-online-consultation"
            )} | REDMED`
          );
          this.meta.updateTag({
            property: "og:description",
            content: `${specialty.specialityName} - ${this.translate.instant(
              "it-is-one-of-the-current-directions-on-the-redmed-platform"
            )}`,
          });
          this.meta.updateTag({
            property: "description",
            content: `${specialty.specialityName} - ${this.translate.instant(
              "it-is-one-of-the-current-directions-on-the-redmed-platform"
            )}`,
          });
          this.meta.updateTag({
            name: "description",
            content: `${specialty.specialityName} - ${this.translate.instant(
              "it-is-one-of-the-current-directions-on-the-redmed-platform"
            )}`,
          });
          this.allSpecialties = specialties;
          this.checkForRouteChanges();
        });
    } else {
      if (this.searchFormGroup.get("onlyForeignDoctors").value) {
        this.seoOptimizationService.setMetaTag(
          this.translate.instant(
            "get-a-video-or-audio-consultation-of-a-doctor-without-leaving-your-home"
          )
        );
      }
      this.searchForDoctors(this.generateSearchString());
      this.checkForSearchGroupChanges();
    }
    this.checkIos();
    this.getInsuranceProviders();
  }

  checkForRouteChanges() {
    this.activeRoute.paramMap
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        if (
          next &&
          (!prev || prev.params.specialtyName !== next.params.specialtyName)
        ) {
          const specialtyId = this.allSpecialties.find(
            (specialty) =>
              specialty.specialityNameLat === next.params.specialtyName
          ).id;
          this.searchFormGroup.get("SpecialityId").setValue(specialtyId);
        }
      });
  }

  getInsuranceProviders() {
    this.insuranceService
      .getIntegratedInsuranceProviders()
      .subscribe((providers) => {
        this.insuranceProvider = providers.data;
        this.insuranceProvider.unshift({
          hasIntegration: true,
          key: null,
          value: this.translate.instant("all"),
        });
      });
  }

  generateSearchableDates(date: Moment | any) {
    const searchableDate = date.clone();
    this.searchableDates = [];
    this.searchableDates.push(searchableDate.valueOf());
    while (this.searchableDates.length !== 4) {
      this.searchableDates.push(searchableDate.add(1, "day").valueOf());
    }
  }

  public checkIos(): void {
    const check = localStorage.getItem("ios");
    const body = document.getElementsByTagName("body");
    const bar = document.getElementById("search-bar");
    if (check === "1") {
      body[0].style.paddingTop = "0";
      this.isIos = true;
    }
  }

  buildSearchFormGroup() {
    this.searchFormGroup = this.formBuilder.group({
      LangId: 1,
      SlotDateFrom: this.formBuilder.control(null),
      SlotDateTo: this.formBuilder.control(null),
      ServiceTypeId: this.formBuilder.control(null),
      SpecialityId: this.formBuilder.control(null),
      GenderId: this.formBuilder.control(null),
      DoctorLangId: this.formBuilder.control(null),
      SpecTimeFrom: this.formBuilder.control(null),
      SpecTimeTo: this.formBuilder.control(null),
      FullName: this.formBuilder.control(null),
      clinic: this.formBuilder.control(null),
      providerId: this.formBuilder.control(null),
      onlyForeignDoctors: this.formBuilder.control(false),
      isInsuranceBubble: this.formBuilder.control(false),
    });
  }

  checkForSearchGroupChanges() {
    this.searchFormGroup.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        startWith(null),
        pairwise()
      )
      .subscribe(([prev, next]: [any, any]) => {
        if (this.searchFormGroup.get("clinic").value) {
          this.initSpecialties();
        }
        if (this.isBubble) {
          this.isBubble = false;
          this.Specialties = this.Specialties.filter((e) => e.id !== 0);
        }

        this.currentPage = 0;
        if (next.onlyForeignDoctors) {
          this.searchFormGroup.get("providerId").disable({ emitEvent: false });
          this.searchFormGroup.get("clinic").disable({ emitEvent: false });
        } else {
          this.searchFormGroup.get("providerId").enable({ emitEvent: false });
          this.searchFormGroup.get("clinic").enable({ emitEvent: false });
          if (prev && prev.onlyForeignDoctors && this.clearDoctorId) {
            this.searchFormGroup
              .get("FullName")
              .setValue(null, { emitEvent: false });
          }
        }
        if (next.ServiceTypeId === 2 && (!prev || prev.ServiceTypeId !== 2)) {
          // this.dialog.open(CovidWarningComponent);
        }
        if (next.SpecialityId) {
          this.activeSpecialtyName = this.Specialties.find(
            (spec) => spec.id === next.SpecialityId
          )?.specialityName;
        } else {
          this.activeSpecialtyName = "";
        }
        if (
          ((next.FullName && !prev && next.SpecialityId) ||
            (next.FullName &&
              prev &&
              prev.SpecialityId !== next.SpecialityId)) &&
          this.clearDoctorId
        ) {
          this.searchFormGroup
            .get("FullName")
            .setValue(null, { emitEvent: false });
        }
        if (this.activeRoute.snapshot.paramMap.get("specialtyName")) {
          if (
            this.isSpecialtyPage &&
            prev &&
            prev.SpecialityId !== next.SpecialityId
          ) {
            this.router.navigateByUrl(
              this.router.url.replace(
                this.activeRoute.snapshot.paramMap.get("specialtyName"),
                this.allSpecialties.find(
                  (specialty) => specialty.id === next.SpecialityId
                ).specialityNameLat
              )
            );
          }
          this.searchForDoctors(this.generateSearchString());
        } else {
          this.replaceDate(next.SlotDateFrom).then(() => {
            if (
              prev &&
              next.FullName &&
              prev.SpecialityId !== next.SpecialityId &&
              this.clearDoctorId
            ) {
              this.searchFormGroup
                .get("FullName")
                .setValue(null, { emitEvent: false });
            }
            if (
              (!prev && next.clinic) ||
              (prev && prev.clinic !== next.clinic && next.clinic !== null)
            ) {
              if (
                this.router.url.includes("clinic") &&
                this.router.url.split("&").length > 1
              ) {
                this.router.navigateByUrl(
                  this.router.url.replace(
                    this.router.url
                      .split("&")
                      .find((str) => str.includes("clinic")),
                    `&clinic=${next.clinic}`
                  )
                );
              } else if (
                this.router.url.includes("clinic") &&
                this.router.url.split("&").length === 1
              ) {
                this.router.navigateByUrl(
                  this.router.url.replace(
                    this.router.url
                      .split("?")
                      .find((str) => str.includes("clinic")),
                    `&clinic=${next.clinic}`
                  )
                );
              } else {
                const navUrl = this.router.url.includes("?")
                  ? this.router.url + `&clinic=${next.clinic}`
                  : this.router.url + `?clinic=${next.clinic}`;
                this.router.navigateByUrl(navUrl);
              }
            } else if (prev && prev.clinic && next.clinic === null) {
              if (this.router.url.split("&").length) {
                this.router.navigateByUrl(
                  this.router.url.replace(
                    this.router.url
                      .split("&")
                      .find((str) => str.includes("clinic")),
                    ``
                  )
                );
              }
              this.router.navigateByUrl(
                this.router.url.replace(this.router.url.split("?")[1], "")
              );
            }
            this.searchForDoctors(this.generateSearchString());
          });
        }
        this.clearDoctorId = true;
      });
  }

  async replaceDate(value?: Moment) {
    let searchDate = value
      ? value
      : this.searchFormGroup.get("SlotDateFrom").value;
    if (this.maxDate.isSameOrBefore(moment(searchDate), "day")) {
      searchDate = this.maxDate.clone();
      (searchDate as Moment).subtract(3, "day");
      this.searchFormGroup
        .get("SlotDateFrom")
        .setValue(searchDate, { emitEvent: false });
    }
    if (this.activeRoute.snapshot.queryParamMap.has("date")) {
      this.generateSearchableDates(searchDate);
      await this.router.navigateByUrl(
        this.router.url.replace(
          this.router.url
            .split("&")
            .find((str) => str.includes("date"))
            .split("=")[1],
          (searchDate as Moment).format("DD-MM-YYYY")
        )
      );
    }
  }

  generateSearchString(): string {
    let searchString = "";
    let i = 0;
    for (const control in this.searchFormGroup.controls) {
      if (
        this.searchFormGroup.get(control).value ||
        this.searchFormGroup.get(control).value === 0 ||
        control === "SpecialityId"
      ) {
        searchString +=
          control === "SlotDateFrom"
            ? control +
              "=" +
              momentGeoTimeParser(this.searchFormGroup.get(control).value) +
              "&"
            : control === "SpecialityId" &&
              this.searchFormGroup.get(control).value === null
            ? control + "=0&"
            : control === "clinic"
            ? "clinic-id=" + this.searchFormGroup.get(control).value + "&"
            : control === "FullName"
            ? "doctor-id=" + this.searchFormGroup.get(control).value + "&"
            : control + "=" + this.searchFormGroup.get(control).value + "&";
      }
      i++;
    }
    searchString += `Days=4&page=${this.currentPage}&size=10`;
    if (this.isBubble) {
      searchString += `&is-bubble=${this.isBubble}`;
    }
    if (this.isInsuranceBubble) {
      searchString += `&is-insurance-bubble=${this.isInsuranceBubble}`;
    }
    let doctor = false;
    if (this.activeRoute.snapshot.queryParamMap.has('doctor')){
      doctor = true;
    }
    if (doctor) {
      searchString += `&secondary-insurance-booking=${doctor}`;
    }
    return searchString;
  }

  getSpecialtyDescription() {
    this.specialtyService
      .getSpecialtyDescription(this.searchFormGroup.get("SpecialityId").value)
      .subscribe(
        (description: any) => {
          const style =
            "<style>p {\n" +
            "      display: flex;\n" +
            "      flex-wrap: wrap;\n" +
            "    }</style>";
          this.specialtyInfo.nativeElement.innerHTML =
            style + description.description.replace(/&nbsp;/g, " ");
          this.isSpecialtyPage = true;
        },
        () => {
          this.isSpecialtyPage = false;
        }
      );
  }

  searchForDoctors(searchString?: string, loadMore = false) {
    this.loadingService.setApplicationLoading(true);
    this.searchService.searchForDoctors(searchString).subscribe(
      (response: any) => {
        if (
          this.searchFormGroup.get("FullName").value &&
          response.content.length &&
          response.content[0].foreignDoctorClinic
        ) {
          this.searchFormGroup
            .get("onlyForeignDoctors")
            .setValue(true, { emitEvent: false });
        }
        this.nothingFound = response.content.length === 0;
        this.totalPageCount = response.totalPages;
        if (loadMore) {
          response.content.forEach((res) => {
            if (
              !this.searchResult.find((result) => result.userId === res.userId)
            ) {
              this.searchResult.push(res);
            }
          });
        } else {
          this.searchResult = response.content;
        }
        this.searchResult.forEach((doctor) => {
          let maxLength = 0;
          for (let slot in doctor.timeSlotDTOs) {
            if (maxLength < doctor.timeSlotDTOs[slot].length) {
              maxLength = doctor.timeSlotDTOs[slot].length;
            }
            if (doctor.timeSlotDTOs[slot].length < 5) {
              const slotLength = doctor.timeSlotDTOs[slot].length;
              for (let i = 0; i < 5 - slotLength; i++) {
                doctor.timeSlotDTOs[slot].push({
                  slotDate: null,
                  slotId: null,
                  specialtyId: this.searchFormGroup.get("SpecialityId").value,
                  timeString: "-",
                });
              }
            }
          }
          for (let slot in doctor.timeSlotDTOs) {
            if (doctor.timeSlotDTOs[slot].length < maxLength) {
              const slotLength = doctor.timeSlotDTOs[slot].length;
              for (let i = 0; i < maxLength - slotLength; i++) {
                doctor.timeSlotDTOs[slot].push({
                  slotDate: null,
                  slotId: null,
                  specialtyId: this.searchFormGroup.get("SpecialityId").value,
                  timeString: "-",
                });
              }
            }
          }
        });
        // if (Intl.DateTimeFormat().resolvedOptions().timeZone !== 'Asia/Tbilisi') {
        //   this.searchResult.forEach(doctor => {
        //     for (let slot in doctor.timeSlotDTOs) {
        //       doctor.timeSlotDTOs[(Number(slot) - getZoneDiffTime())] = doctor.timeSlotDTOs[slot];
        //       delete doctor.timeSlotDTOs[slot];
        //     }
        //   });
        // }
        this.totalResultCount = response.totalElements;
        if (this.isSpecialtyPage) {
          this.getSpecialtyDescription();
        }
        this.loadingService.setApplicationLoading(false);
      },
      () => {
        this.loadingService.setApplicationLoading(false);
      }
    );
  }

  public showDetailFilter(): void {
    this.toggleDetail = !this.toggleDetail;
  }

  public searchData(loadMore = false) {
    if (loadMore) {
      this.currentPage += 1;
    }
    this.searchForDoctors(this.generateSearchString(), loadMore);
  }

  public initServiceTypes() {
    this.productService.getServices().subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.serviceTypes = res["result"];
          }
          // this.dataInitialized = true;
        }
      },
      (error) => {
        // this.Auth.checkAccess(error);
      }
    );
  }

  public initSpecialties() {
    this.specialtyService
      .getAllSpecialties(
        "",
        this.activeRoute.snapshot.queryParamMap.get("clinic") ||
          this?.searchFormGroup?.get("clinic")?.value
      )
      .subscribe((res) => {
        if (res) {
          this.Specialties = res;
          this.Specialties.unshift({
            id: null,
            sortingNumber: "0",
            specialityId: null,
            specialityName: this.translate.instant("all"),
            specialityNameEng: "all",
            specialityNameLat: "yvela",
            specialityShortDesc: this.translate.instant("all"),
            specialityShortDescEng: "yvela",
          });
        }
      });
  }

  public initGender() {
    this.userService.getGenders().subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.gender = res["result"];
          }
        }
      },
      (error) => {
        // this.Auth.checkAccess(error);
        console.log("error");
      }
    );
  }

  public initLanguages() {
    this.regionService.getLanguages().subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.languages = res["result"];
          }
        }
      },
      (error) => {
        //
      }
    );
  }

  public initCities() {
    this.regionService.getCities().subscribe(
      (res) => {
        if (res) {
          if (res.hasOwnProperty("result")) {
            this.cities = res["result"];
          }
        }
      },
      (error) => {
        //
      }
    );
  }

  toggle(e) {
    this.active = [];
    this.active[e] = !this.active[e];
  }

  getDoctorTimeSlotsBySpecialty(event, doctor) {
    this.loadingService.setApplicationLoading(true);
    let searchTimeStamp;
    if (this.searchFormGroup.get("SlotDateFrom").value instanceof Date) {
      searchTimeStamp = momentGeoTimeParser(
        moment(this.searchFormGroup.get("SlotDateFrom").value as Date)
      );
    } else {
      searchTimeStamp = momentGeoTimeParser(
        moment(this.searchFormGroup.get("SlotDateFrom").value)
      );
    }
    let params = new HttpParams();
    params = params.append("SpecialtyId", event.specialtyId);
    params = params.append("DoctorId", event.doctorId);
    params = params.append("SlotDateFrom", searchTimeStamp);
    params = params.append(
      "ServiceTypeId",
      this.searchFormGroup.get("ServiceTypeId").value
    );
    params = params.append("Days", "4");
    if (doctor.clinic) {
      params = params.append("clinic-id", doctor.clinic.id);
    }
    this.API.searchDoctorsSlotsForSpec(params).subscribe(
      (response: any[]) => {
        // if (
        //   Intl.DateTimeFormat().resolvedOptions().timeZone !== "Asia/Tbilisi"
        // ) {
        //   for (let slot in response[0].timeSlotDTOs) {
        //     const newTimeObjectKey = Number(slot) - getZoneDiffTime();
        //     response[0].timeSlotDTOs[newTimeObjectKey] =
        //       response[0].timeSlotDTOs[slot];
        //     delete response[0].timeSlotDTOs[slot];
        //   }
        // }
        for (let slot in response[0].timeSlotDTOs) {
          if (response[0].timeSlotDTOs[slot].length < 5) {
            const slotLength = response[0].timeSlotDTOs[slot].length;
            for (let i = 0; i < 5 - slotLength; i++) {
              response[0].timeSlotDTOs[slot].push({
                slotDate: null,
                slotId: null,
                specialtyId: this.searchFormGroup.get("SpecialityId").value,
                timeString: "-",
              });
            }
          }
        }
        this.searchResult[this.searchResult.indexOf(doctor)] = response[0];
        this.loadingService.setApplicationLoading(false);
      },
      () => {
        this.loadingService.setApplicationLoading(false);
      }
    );
  }

  getDoctor(doctor): any {
    return this.searchResult.find((doc) => {
      if (doctor.clinic) {
        return (
          doc.userId === doctor.userId && doc.clinic.id === doctor.clinic.id
        );
      } else {
        return doc.userId === doctor.userId;
      }
    });
  }

  checkForBackwardDisable() {
    return moment(this.searchFormGroup.get("SlotDateFrom").value).isSame(
      new Date(),
      "day"
    );
  }

  searchNextDate(next: boolean) {
    const currentDate = this.searchFormGroup.get("SlotDateFrom")
      .value as Moment;
    if (next) {
      this.searchFormGroup
        .get("SlotDateFrom")
        .setValue(currentDate.add(4, "day"));
      this.generateSearchableDates(currentDate);
    } else {
      const currentSearchDay = currentDate;
      const today = moment().add(4, "day");
      if (today.isSameOrBefore(currentSearchDay)) {
        this.searchFormGroup
          .get("SlotDateFrom")
          .setValue(currentDate.subtract(4, "day"));
      } else {
        const daysToSubtract = currentSearchDay.date() - today.date() + 4;
        this.searchFormGroup
          .get("SlotDateFrom")
          .setValue(currentDate.subtract(daysToSubtract, "day"));
      }
      this.generateSearchableDates(currentDate);
    }
  }

  checkForNextDisable() {
    const lastDate = this.maxDate.clone().subtract(3, "day");
    return moment(this.searchFormGroup.get("SlotDateFrom").value).isSameOrAfter(
      lastDate,
      "day"
    );
  }

  navigateToClosestAvailableDate(change: {
    specialtyId: number;
    date: number;
    keyword?: number;
  }) {
    const selectedDate = moment(change.date);
    this.searchFormGroup
      .get("SlotDateFrom")
      .setValue(selectedDate, { emitEvent: false });
    this.searchFormGroup.get("SpecialityId").setValue(change.specialtyId);
    this.searchFormGroup
      .get("FullName")
      .setValue(change.keyword, { emitEvent: false });
    this.clearDoctorId = false;
  }

  reinitializeSearch(data) {
    this.searchFormGroup
      .get("SpecialityId")
      .setValue(data.specId, { emitEvent: false });
    this.searchFormGroup.get("ServiceTypeId").setValue(data.serviceType);
  }

  removeClinicFilter() {
    this.searchFormGroup.get("clinic").setValue(null);
  }

  getClinicName(value: any) {
    return this.clinics.find((clinic) => clinic.id === value).name;
  }

  getProviderName(value: any) {
    return this.insuranceProvider.find((provider) => provider.key === value)
      .value;
  }

  removeInsuranceProvider() {
    this.searchFormGroup.get("providerId").setValue(null);
  }

  private getClinics() {
    this.clinicService.getClinics().subscribe((clinics) => {
      this.clinics = clinics.data;
      this.clinics.unshift({
        homeVisitEnabled: false,
        id: null,
        name: this.translate.instant("all"),
        selfApproveOrders: null,
        selfManageCalendars: null,
      });
    });
  }
}

export interface SlotForPreRender {
  date: Moment;
  specialityId: number;
  doctorTimeSlots: {
    isActive: boolean;
    time: string;
    serviceTypeId: number;
    slotId: number;
  }[];
}

export interface SlotForRender {
  date: Moment;
  slotForPreRender: SlotForPreRender;
}
